import { Anchor, Group } from '@mantine/core';

import { useAction } from 'hooks/use-action';
import { useInbox, useInboxQuery } from 'hooks/use-inbox';
import { NotificationService } from 'services/NotificationService';

const InboxActions = () => {
    const { category, team, company, unreadCount } = useInbox();
    const query = useInboxQuery();

    const hasSelection = category !== null || Boolean(team) || Boolean(company);

    const [markAllAsRead, isMarkingAll] = useAction(() => NotificationService.readAll());
    const [markSelectionAsRead, isMarkingSelection] = useAction(() => NotificationService.readAll(query));

    if (!unreadCount) {
        return null;
    }

    return (
        <Group gap="md" wrap="nowrap">
            {hasSelection && (
                <Anchor
                    component="button"
                    fz="sm"
                    fw={500}
                    style={{ whiteSpace: 'nowrap' }}
                    disabled={isMarkingSelection}
                    onClick={() => markSelectionAsRead().then()}
                >
                    {isMarkingSelection ? 'Marking…' : 'Mark selection read'}
                </Anchor>
            )}
            <Anchor
                component="button"
                fz="sm"
                fw={500}
                style={{ whiteSpace: 'nowrap' }}
                disabled={isMarkingAll}
                onClick={() => markAllAsRead().then()}
            >
                {isMarkingAll ? 'Marking…' : 'Mark all read'}
            </Anchor>
        </Group>
    );
};

export { InboxActions };
